import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FieldConfig } from '../../models/common-models';
import { FormArray, FormBuilder, UntypedFormGroup } from '@angular/forms';
import { config } from 'rxjs';
import { GuestService } from 'src/app/shared/services/guest.service';

@Component({
    selector: 'app-form-checkbox',
    templateUrl: './form-checkbox.component.html',
    styleUrls: ['./form-checkbox.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class FormCheckboxComponent implements OnInit {

  config: FieldConfig;
  group: UntypedFormGroup;
  configName: any;
  innerHTMLdata: boolean = false;
  constructor(public gs: GuestService) { }

  ngOnInit() {
    this.configName = this.group.get(this.config.name);   
    this.innerHTMLdata = this.config.innerHTMLdata ? this.config.innerHTMLdata : false;
  }

}
